export const SET_MODAL_VISIBILITY = 'SET_MODAL_VISIBILITY';
export const FETCH_ARTICLES = 'FETCH_ARTICLES';



// WEBPACK FOOTER //
// ./src/actions/types.js